<template>
  <select v-model="handler" @change="input" class="form-control">
    <option value="normal">normal</option>
    <option value="flex-start">left</option>
    <option value="center">center</option>
    <option value="flex-end">right</option>
    <option value="space-between">space between</option>
    <option value="space-around">space around</option>
    <option value="space-evenly">space evenly</option>
  </select>
</template>

<script>
export default {
  props: ['value'],
  data(){
      return {
          handler:null,
      }
  },
  mounted(){
      this.handler = this.value;
  },
  methods:{
    input(){
        console.log('input justify-content new val', this.handler)
        this.$emit('change',this.handler);
    },

  }

}
</script>
